import React from "react";
import { useForm, Controller } from "react-hook-form";
import {
  TextField,
  Button,
  Container,
  Typography,
  Box,
  Grid,
} from "@mui/material";
import api from "../../api/api"; // Certifique-se de ajustar o caminho do seu arquivo API

const CreateSeller = ({ setWarning, handleOpenSnackbar, onSave }) => {
  const { control, handleSubmit, setValue, getValues } = useForm({
    defaultValues: {
      name: "",
      email: "",
      phone: "",
      docNumber: "",
      address: {
        street: "",
        number: "",
        neighborhood: "",
        city: "",
        state: "",
      },
    },
  });

  const formatAddress = () => {
    const { street, number, neighborhood, city, state } = getValues("address");
    return `${street}, Nº ${number}, ${neighborhood}, ${city} - ${state}`;
  };

  const onSubmit = async (data) => {
    const formattedAddress = formatAddress();
    const sellerData = {
      ...data,
      address: formattedAddress,
    };

    try {
      const response = await api.post("/sellers", sellerData);
      if (response.status === 200 || response.status === 201) {
        setWarning({
          type: "success",
          message: "Vendedor Criado!",
        });
        handleOpenSnackbar();
        onSave();
      } else {
        setWarning({
          type: "error",
          message: "Falha ao criar o vendedor!",
        });
        handleOpenSnackbar();
      }
    } catch (error) {
      console.error("Failed to create seller", error);
      setWarning({
        type: "error",
        message: "Erro ao criar o vendedor!",
      });
      handleOpenSnackbar();
    }
  };

  return (
    <Box sx={{ padding: 5 }}>
      <Typography variant="h5" marginBottom={3}>
        Criar Vendedor
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Nome"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Email"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controller
              name="phone"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Telefone"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controller
              name="docNumber"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="CPF/CNPJ"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Typography variant="h6" gutterBottom mt={2}>
              Endereço
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controller
              name="address.street"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Rua"
                  variant="outlined"
                  fullWidth
                  sx={{ xs: 12, md: 6 }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controller
              name="address.number"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Número"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controller
              name="address.neighborhood"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Bairro"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controller
              name="address.city"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Cidade"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controller
              name="address.state"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Estado"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ marginTop: 2 }}
            >
              Criar
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default CreateSeller;
